import GoogleDrive from '@uppy/google-drive'
import Dropbox from '@uppy/dropbox'
import Url from '@uppy/url'
import Hebrew from '@uppy/locales/lib/he_IL'
import English from '@uppy/locales/lib/en_US'
import Dashboard from '@uppy/dashboard'

export const uppyPlugins = { Dashboard, GoogleDrive, Dropbox, Url }

export const languagePlugins = { Hebrew, English }
